import React from 'react';

import { Box, makeStyles, Theme } from '@material-ui/core';

import { LEGEND_ITEMS } from '../constants/legend-items';
import LegendItem from '../data-types/legend-item-data';

const useStyles = makeStyles((theme: Theme) => ({
  legendColor: {
    height: '20px',
    width: '20px',
  },
}));

const Legend = () => {
  const classes = useStyles();

  return (
    <Box>
      <Box display="flex">
        {LEGEND_ITEMS.map((item: LegendItem) => {
          return (
            <Box display="flex" mr={3} key={item.color}>
              <Box
                className={classes.legendColor}
                mr={1}
                style={{ background: item.color, border: '1px solid' }}
              />
              <Box>{item.description}</Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default Legend;
